import BaseContractService from "./baseContractService";
import Web3Service from "../services/web3Service";
import abi from "../abi/dolls.json";

class DollsContractService extends BaseContractService {
  constructor() {
    super(process.env.VUE_APP_DOLLS_CONTRACT_ADDRESS, abi);
  }

  mint(quantity, price, from) {
    const mintAction = this.contract.methods.mint(quantity);

    let options = {
      from,
      value: (parseFloat(price * quantity) * 10 ** 18).toString(),
    };
    return this.estimateGas(mintAction, options);
  }

  balanceOf(address) {
    return this.contract.methods.ownerSupply(address).call();
  }

  maxSupply() {
    return this.contract.methods.maxSupply().call();
  }

  mintPrice() {
    return this.contract.methods.mintPrice().call();
  }

  totalSupply() {
    return this.contract.methods.totalSupply().call();
  }

  isMintActive() {
    return this.contract.methods.startSales().call();
  }
}

export default new DollsContractService();
